import { DeleteObjectCommand } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';

import client from './client';
import { BucketName } from './types';

const deleteObjectCommand = (key: string, bucketName: BucketName) =>
  new DeleteObjectCommand({
    Bucket: bucketName,
    Key: key
  });

const uploadImage = async (
  imageName: string,
  file: ReadableStream<Uint8Array>,
  bucketName: BucketName,
  folderName?: string
) => {
  try {
    const parallelUploads3 = new Upload({
      client,
      params: {
        Bucket: bucketName,
        Key: folderName ? `${folderName}/${imageName}` : imageName,
        Body: file,
        ContentType: 'image/webp'
      },
      queueSize: 10,
      partSize: 5 * 1024 * 1024,
      leavePartsOnError: false
    });

    await parallelUploads3.done();

    return { imageName };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    // important: rethrow the error so that multi-upload can fail properly
    throw e;
  }
};
export { deleteObjectCommand, uploadImage };
